import CameraOffIcon from "@uui/CameraOff";
import MicrophoneOffIcon from "@uui/MicrophoneOff01";

import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtext,
  EmptyStateTitle,
} from "@rui/EmptyStateContainer";

const OPTS_BY_TYPE = {
  talk_time: {
    Icon: MicrophoneOffIcon,
    title: "Not enough talk time",
  },
  camera: {
    Icon: CameraOffIcon,
    title: "Not enough visual data",
  },
};

const InsufficientData = ({
  children,
  type,
}: {
  children: React.ReactNode;
  type: "talk_time" | "camera";
}) => {
  const { Icon, title } = OPTS_BY_TYPE[type];
  return (
    <EmptyStateContainer sx={{ minHeight: "150px" }}>
      <EmptyStateIcon Icon={Icon} />
      <EmptyStateTitle>{title}</EmptyStateTitle>
      <EmptyStateSubtext>{children}</EmptyStateSubtext>
    </EmptyStateContainer>
  );
};

export default InsufficientData;
